const removeAmpersand = (text?: string) => {
    if (!text || typeof text !== 'string') {
        return '';
    }
    
    return text.replace(/&amp;/g, '&');
};

export default removeAmpersand;